<template>
  <div>
    <div class="w-full input-group">
      <input
        v-model="queryString.query"
        type="text"
        placeholder="Search Documents"
      >
    </div>
    <div :class="{ 'h-24 load load--fill': loading }">
      <section
        v-if="foldersExist && !loading"
        class="flex flex-wrap items-stretch"
      >
        <div
          is="Folder"
          v-for="folder in folders.data"
          :key="folder.uuid"
          :folder="folder"
        />
      </section>
      <div
        v-if="!foldersExist && !loading"
        class="empty"
      >
        <section>
          <h2 v-text="'There are no folders'" />
          <p>Folders give you a way to organize and share files.</p>
          <a
            v-can="'edit-documents'"
            href="#"
            class="btn btn--border"
            @click.prevent="$store.commit('documentOpenCreateFolderModal')"
            v-text="'Create a folder'"
          />
        </section>
      </div>
    </div>
    <CreateFolderModal @documentFolderHasBeenCreated="fetch" />
    <DeleteFolderModal />
  </div>
</template>

<script type="text/babel">
import URI from 'urijs'
import CreateFolderModal from './_modals/CreateFolderModal'
import Folder from './Folder'
import DeleteFolderModal from './_modals/DeleteFolderModal'

export default {
  name: 'Folders',
  components: {
    CreateFolderModal,
    DeleteFolderModal,
    Folder,
  },
  data() {
    return {
      folders: {
        data: [],
      },
      loading: false,
      queryString: {
        query : '',
      },
    }
  },
  computed: {
    foldersExist() {
      return this.folders.data.length
    },
    fetchUrl() {
      return new URI('').setSearch(this.queryString).toString()
    },
  },
  watch: {
    queryString: {
      handler: _.debounce(function () {
        history.pushState(null, null, this.fetchUrl)

        this.fetch()
      }, 500),
      deep: true,
    },
  },
  async mounted() {
    await this.$nextTick()

    this.queryString = Object.assign(this.queryString, new URI().query(true))

    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true

      this.$api.active().get('folders' + this.fetchUrl).then((response) => {
        this.folders = response.data
        this.loading = false
      })
    },
  },
}
</script>
